import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/jobs/",
)({
  beforeLoad: ({ params }) => {
    // Redirect to the job posts page
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/jobs/post",
      params: {
        organizationBusinessUnitId: (
          params as { organizationBusinessUnitId: string }
        ).organizationBusinessUnitId,
      },
    });
  },
});
